<template>

<div id="reptree-container" :class="{ 'reptree-container-background-light' : !isDark,
                    'reptree-container-background-dark' : isDark}">
      <span v-for="move in gameMoves" v-bind:key="move.index">
        <span @click="onClick(move.index)"
                :class="{
                  'reptree-selected-text-dark' : (move.selected) && isDark,
                  'reptree-move-text-dark'     : (!(move.selected)) && isDark,
                  'reptree-selected-text-light' : (move.selected) && !isDark,
                  'reptree-move-text-light'     : (!(move.selected)) && !isDark
                }">
          {{ move.san }}
        </span>
        &nbsp;
        <span v-if="(move.index % 2) == 1">
          &nbsp;
        </span>
      </span>
  </div>
</template>

<script setup>

import { ref, watch } from 'vue'
import { computed } from "@vue/reactivity"
import { useConnectionStore } from '@/stores/connectionStore';

const emit = defineEmits(['move-click'])

const props = defineProps({
  gameMoves : {
       type : Array,
       default : []
  },
  moveDirection : {
    type : Number,      
    default : 0
  },
  gameMoveTrigger : {
       type : Number,
       default : 0
   }
   
 })
 
 const connectionStore = useConnectionStore()
 const isDark = ref(connectionStore.getDarkmode != "light")

 var currentSelectedMove = -1

 const gameMoves = computed({
    get() {
      return props.gameMoves
    }
  })

 const gameMoveTrigger = computed({
    get() {
      return props.gameMoveTrigger
    }
  })

  const moveDirection = computed({
    get() {
      return props.moveDirection
    }
  })

  function onClick(index) {
    //console.log(" move click index",index)
    if (currentSelectedMove >= 0)
      gameMoves.value[currentSelectedMove].selected = false
    if (index >= 0)
      gameMoves.value[index].selected = true
    currentSelectedMove = index
    emit("move-click",index)
  }

  watch(gameMoves, (newVal,oldVal) => {
    //console.log('*********** gameMoves changed',newVal)
    currentSelectedMove = -1
  })

  watch(moveDirection, (newVal,oldVal) => {
    //console.log('*********** moveDirection changed',newVal)

    if (newVal < 0) {
      if (currentSelectedMove >= 0)
        onClick(currentSelectedMove - 1)
    }
    else
    if (newVal > 0)
      if (currentSelectedMove < gameMoves.value.length - 1)
        onClick(currentSelectedMove + 1)
  })
</script>

<style scoped>

#reptree-container {
  position : relative;
  line-height : 1.5em;
}

.reptree-container-background-dark {
  background-color: #403726;
}

.reptree-container-background-light {
  background-color : #ebf2f2;
}

.reptree-move-text-light {
  color : rgb(13,110,253)
}
.reptree-move-text-dark {
  color : #fff;
}
.reptree-selected-text-light {
  color : blue;
  background : yellow;
  padding: 2px;
  border : solid 1px black;
  border-radius: 3px;
}

.reptree-selected-text-dark {
  color : #fff;
  background : gray;
  padding: 2px;
  border : solid 1px #fff;
  border-radius: 3px;
}

.movelist-text-left {
  text-align: left;
}
</style>